/* eslint-disable react-hooks/exhaustive-deps */
import { List } from '@mui/material';
import { getPurePlaybookList } from '@Store/feature/purePlaybookSlice';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Dealspace } from '../../../config/dealspace';
import { DealProjectDTO } from '../../../helper/Interfaces';
import {
  getAssetsPlaybooks,
  postAssets,
} from '../../../store/feature/assetsSlice';
import { getIsUserIMO } from '../../../store/feature/directory';
import { useAppSelector } from '../../../store/hooks';
import CreatePlaybook from '../../Layout/Navigation/CreatePlaybook';
import classes from './NavPlaybook.module.css';
import NavPlaybookItem from './NavPlaybookItem';
import { useEffectAsync, UserHelper } from '@Helper/Infra';
import { useDispatch } from 'react-redux';
import { RootAssets } from '@Config/rootAssets';
import { PlayBook } from '@Config/playBook';

interface NavPlaybookProps {
  selectedDealspace: Dealspace;
  refresh: boolean;
  menuShow: boolean;
}

export default function NavPlaybook({
  selectedDealspace,
  refresh,
  menuShow,
}: NavPlaybookProps) {
  const playBooks = useAppSelector(getAssetsPlaybooks);
  const isUserImo = useAppSelector(getIsUserIMO);
  const { id } = useParams();
  const purePlaybooks = useAppSelector(getPurePlaybookList);
  const [relatedPlaybooks, setRelatedPlaybooks] = useState<DealProjectDTO[]>([
    ...(purePlaybooks ?? []),
  ]);
  const [currentPlaybooks, setcurrentPlaybooks] = useState<PlayBook[]>(
    playBooks ?? []
  );

  const userHelper = new UserHelper();

  useEffectAsync(async () => {
    const haveDealspace = (await userHelper.getAssets()) as RootAssets;
    setcurrentPlaybooks(haveDealspace.playbooks ?? []);
    setRelatedPlaybooks([...(purePlaybooks ?? [])]);
  }, [purePlaybooks]);

  return (
    <div className={classes.SinglePlaybook}>
      <List>
        {isUserImo ? (
          <div style={{ marginBottom: 5 }}>
            <CreatePlaybook refresh={menuShow} setRefresh={() => {}} />
          </div>
        ) : (
          <div></div>
        )}
        {relatedPlaybooks
          .filter(
            item =>
              item.functionalArea &&
              item.functionalArea?.isDeleted !== true &&
              item.project?.isDeleted !== true &&
              currentPlaybooks
                .filter(i => i.dealspaceId === id)
                .map(p => p.id)
                .includes(item.id)
          )
          .sort((a, b) =>
            a.project.name.toLocaleLowerCase() >
            b.project.name.toLocaleLowerCase()
              ? 1
              : -1
          )
          .sort((a, b) => (a.functionalArea?.isIMO ? -1 : 1))
          ?.map((playBook, index) => {
            return (
              <NavPlaybookItem
                key={index}
                playBook={playBook}
                openDrawer={menuShow}
              />
            );
          })}
      </List>
    </div>
  );
}
